import { getPurchaseServiceURL } from "@/core/utils/service-urls"

export const clearReceiptOwnerContactInformation =
  (id: string, region: string) => (optOutCallback: any) => {
    const headers = new Headers({
      "Content-Type": "application/json",
    })

    fetch(`${getPurchaseServiceURL(region)}/receiptowner/${id}`, {
      headers,
      method: "delete",
      mode: "cors",
    })
      .then(async (response) => {
        let data = null
        try {
          data = await response.json()
          // eslint-disable-next-line no-empty
        } catch (_) {}
        optOutCallback({ code: response.status, data })
      })
      .catch((err) => {
        optOutCallback({ code: err.status })
      })
  }
